import { Component, Inject, OnInit } from '@angular/core';
import { I18NEXT_SERVICE, I18NextPipe, ITranslationService } from 'angular-i18next';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { FeatureService } from '../../features/feature.service';

interface LangulageDropdownInterface {
  label?: string;
  value?: string;
}

@Component({
  selector: 'hb-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
})
export class LanguageSelectorComponent implements OnInit {

  public readonly languages: LangulageDropdownInterface[] = [
    { value: 'en', label: this.i18NextPipe.transform('en') },
    { value: 'zh', label: this.i18NextPipe.transform('zh') },
  ];

  public selectedLanguage: LangulageDropdownInterface = {};
  public selectedLabel: string;

  public regionalisationEnabled: boolean = false;

  constructor(@Inject(I18NEXT_SERVICE) private i18next: ITranslationService, private featureService: FeatureService, private i18NextPipe: I18NextPipe,) {
  }

  public ngOnInit(): void {
    this.regionalisationEnabled = this.featureService.regionalisationEnabled();
    this.selectedLanguage = this.getCurrentOption(this.i18next.language);
  }

  public onLanguageSelected(e: DropdownChangeEvent) {
    if(e.originalEvent){ // skip on page load call
      if(this.i18next.language !== e.value){
        void this.i18next.changeLanguage(e.value).then(() => {
          location.reload();
        });
      }
    }
  }

  private getCurrentOption(lng): LangulageDropdownInterface{
    const langoption =  this.languages.find(lang=>lang.value===lng);

    return langoption || this.languages[0];
  }
}
